import HeatModeDeperditionsConnues from "./HeatModeDeperditionsConnues";
import HeatModeDeperditionsCoef from "./HeatModeDeperditionsCoef";
import HeatModeDeperditionsInvoice from "./HeatModeDeperditionsInvoice";
import HeatModeDeperditionsDPE from "./HeatModeDeperditionsDPE";
import { SvgCoefficient, SvgDeperditions, SvgDpe, SvgExpertMethod, SvgFacture } from "components/svg";
import HeatModeExpertMethod from "./HeatModeExpertMethod";

const deperditionMethods = [
  { code: '0', label: 'SELECT_LOSS_KNOWN', component: HeatModeDeperditionsConnues, icon: <SvgDeperditions /> },
  { code: '3', label: 'SELECT_LOSS_COEF', component: HeatModeDeperditionsCoef, icon: <SvgCoefficient /> },
  { code: '1', label: 'SELECT_LOSS_DPE', component: HeatModeDeperditionsDPE, icon: <SvgDpe /> },
  { code: '2', label: 'SELECT_LOSS_INVOICE', component: HeatModeDeperditionsInvoice, icon: <SvgFacture /> },
  { code: '4', label: 'SELECT_EXPERT_METHOD', component: HeatModeExpertMethod, icon: <SvgExpertMethod /> },
];

export const getLossMethods = (availableLossMethods: any) => {
  if (!availableLossMethods) return deperditionMethods

  try {
    const availableLossMethodsArray = availableLossMethods.split(',')
    return deperditionMethods.filter(dm => availableLossMethodsArray.find((alm: any) => alm === dm.code))
  } catch {
    return deperditionMethods
  }
}